import GroupEnrollmentForm from 'components/forms/group_enrollment_form';
import React from 'react';

const GroupHealthEnrollment = () => {
  return (
    <div className='relative'>
      <GroupEnrollmentForm />
    </div>
  );
}

export default GroupHealthEnrollment;
